import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import React, { useCallback } from 'react';
import ContextualAppDownloadBanner from '@clearscore/ui.shared.contextual-app-download-banner';
import useWesbiteTracking from '@clearscore-group/lib.hooks.use-website-tracking';
var getWindowProps = function getWindowProps() {
  return {
    source: window.location.pathname
  };
};
var useTracking = function useTracking() {
  var track = useWesbiteTracking();
  var trackBannerViewed = useCallback(function () {
    return track({
      name: 'fe_mobile_web_smart_banner_viewed',
      // Removed other variants, so variant will always be BUTTON now
      props: _objectSpread({
        variant: 'BUTTON'
      }, getWindowProps())
    });
  }, [track]);
  var trackBannerClicked = useCallback(function () {
    return track({
      name: 'fe_mobile_web_smart_banner_clicked',
      // Removed other variants, so variant will always be BUTTON now
      props: _objectSpread({
        variant: 'BUTTON'
      }, getWindowProps())
    });
  }, [track]);
  return {
    trackBannerViewed: trackBannerViewed,
    trackBannerClicked: trackBannerClicked
  };
};
var WebsiteAppDownloadBanner = function WebsiteAppDownloadBanner(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTracking = useTracking(),
    trackBannerViewed = _useTracking.trackBannerViewed,
    trackBannerClicked = _useTracking.trackBannerClicked;
  return /*#__PURE__*/React.createElement(ContextualAppDownloadBanner, _objectSpread({
    onBannerClick: trackBannerClicked,
    onBannerView: trackBannerViewed
  }, props));
};
export default WebsiteAppDownloadBanner;